'use client';

import { Listing } from '@/utils/platform-api/__generated__/graphql';
import { mustCallToBookForListing } from '@/utils/must-call-to-book-for-listing';
import { useFormStatus } from 'react-dom';
import { ClientBrandConfig } from 'types/brand-config';

import Button from '@/components/ui/button';
import { CallToBookLink } from '@/components/ui/call-to-book-link';

import { openAvailabilityDatePicker } from '../utils/open-availability-date-picker';

interface ReserveBtnProps {
  brand: ClientBrandConfig;
  listing: Listing;
  hasDates: boolean;
  arriveDate?: string;
}

const ReserveBtn = ({
  brand,
  listing,
  hasDates,
  arriveDate,
}: ReserveBtnProps) => {
  const { pending } = useFormStatus();
  const mustCallToBook = mustCallToBookForListing(
    arriveDate,
    listing,
    brand.timezone
  );

  return (
    <div className="flex w-full flex-col gap-2">
      {!mustCallToBook && (
        <Button
          normalCase
          className="w-full p-4"
          type={hasDates ? 'submit' : 'button'}
          disabledCTA={pending}
          disabled={pending}
          loading={pending}
          onClick={hasDates ? undefined : openAvailabilityDatePicker}
        >
          {hasDates ? 'Reserve' : 'Check Availability'}
        </Button>
      )}
      {hasDates && !mustCallToBook && (
        <div className="text-center">
          <span className="text-xs font-normal text-gray-500 lg:text-sm">
            You won&apos;t be charged yet
          </span>
        </div>
      )}
      {hasDates && mustCallToBook && (
        <CallToBookLink phone={brand.phone} showPhoneIcon />
      )}
    </div>
  );
};

export default ReserveBtn;
